var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83268 8.4987C4.83268 10.7987 6.69935 12.6654 8.99935 12.6654C11.2993 12.6654 13.166 10.7987 13.166 8.4987C13.166 6.1987 11.2993 4.33203 8.99935 4.33203C6.69935 4.33203 4.83268 6.1987 4.83268 8.4987ZM0.666016 8.4987C0.666016 13.0987 4.39935 16.832 8.99935 16.832C13.5993 16.832 17.3327 13.0987 17.3327 8.4987C17.3327 3.8987 13.5993 0.165363 8.99935 0.165363C4.39935 0.165363 0.666016 3.8987 0.666016 8.4987ZM15.666 8.4987C15.666 12.182 12.6827 15.1654 8.99935 15.1654C5.31602 15.1654 2.33268 12.182 2.33268 8.4987C2.33268 4.81536 5.31602 1.83203 8.99935 1.83203C12.6827 1.83203 15.666 4.81536 15.666 8.4987Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.c6f1dead2ebcdae99bc4c6d543b15ba0.svg";
export { ForwardRef as ReactComponent };